module.exports = __webpack_public_path__ + "img/B户型.b8084a28.png";